const getDefinedOrNullValue = (value) =>
  [null, undefined, '', NaN].includes(value) ? null : value;

export default getDefinedOrNullValue;
